import { render, staticRenderFns } from "./PasswordRecoveryDenied.vue?vue&type=template&id=717de81a"
import script from "./PasswordRecoveryDenied.vue?vue&type=script&lang=js"
export * from "./PasswordRecoveryDenied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports